import { API_BASE_URL } from './constants';

/**
 * Utility to get the full profile image URL.
 * Syncs with the backend storage structure.
 */
export const getProfileImageUrl = (path) => {
    if (!path) return null;
    if (typeof path !== 'string') return null;

    // If it's already an absolute URL (http), clean it first if it points to the old domain
    if (path.startsWith('http')) {
        return path.replace('yc.churchsocial.us', 'yc.intuitlms.online');
    }

    if (path.startsWith('data:') || path.startsWith('file:') || path.startsWith('blob:')) {
        return path;
    }

    // Clean the path
    let cleanPath = path.startsWith('/') ? path : `/${path}`;

    // Fallback for legacy filenames that don't include the full storage path
    if (!cleanPath.includes('/uploads/')) {
        cleanPath = `/uploads/profile-images${cleanPath}`;
    }

    // Get the base server URL (stripping /api if the uploads are served from root)
    const serverBase = API_BASE_URL.replace('/api', '');

    return `${serverBase}${cleanPath}`;
};

export const getImageUrl = getProfileImageUrl;
